module.exports = __webpack_public_path__ + "static/media/memory_icon--active.38754bd1.svg";